// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#goldprice[data-v-8a8b27ac]{height:60vw}", ""]);
// Exports
module.exports = exports;
